module.exports = __webpack_public_path__ + "static/media/close-white.6fdaaf22.svg";